/**
 * 徽章 code → PNG 图标映射（growth/summary 下发的徽章族，一族一图不分档）
 * 无图徽章返回空串 → Center 徽章 chip 回退到纯 emoji+文字形态
 */
const iconMap = {
  badge_explorer: require('@/assets/icons/badges/badge_explorer.png'),
  badge_image_master: require('@/assets/icons/badges/badge_image_master.png'),
  badge_inspection_master: require('@/assets/icons/badges/badge_inspection_master.png'),
  badge_dispatch_master: require('@/assets/icons/badges/badge_dispatch_master.png'),
  badge_delivery_master: require('@/assets/icons/badges/badge_delivery_master.png')
}

export function getBadgeIcon (code) {
  return iconMap[code] || ''
}

export default iconMap
